import * as React from 'react';
import { ICostBooking } from 'reducers/bookings/models';
import { DataTable } from 'damco-components';
import { findObjId } from 'utilities/util';
import { DialogSubTableWrapper } from './DialogSubTableWrapper';
import { InPageDialog } from 'damco-components';
import CostColumnsData from '../../../views/job-costing/utils/CostColumnsData';
import { currentPageMode } from '../../../constants/customs';

interface IProps {
    data: any[];
    columns: any[];
    subColumns: any[];
    showSub: boolean;
    distribution: number;
    index: number;
    type: string,
    target: string,
    isEditable: boolean;
    isSelectable: boolean;
    subTableRef: any;
    quantity: number;
    updateChildren: boolean;
    targetFunctionality: number;
    displayDistribution: boolean;
    fetchData: (e: any, table: any) => void,
    setCurrentIndex: (e: any) => void;
    returnRef: (e: any) => void;
    onSelectCallBack: (e: any[] | null) => void;
    onUpdateCallback: (e: any, index: number, bol: boolean) => void;
    closeMethod: () => void;
    deleteCharge?: (item: any, selectedTable: any) => void;
    isExtraDocumentFeatureEnabled: boolean;
    classNameString?: string;
}
interface IHandlerState {
    prevIndex: number,
    wasOpen: boolean,
}
interface IState {
    isEventAdded: boolean,
    shouldCheck: boolean,
    showDialog: boolean,
    errorMsg: string,
    timeout: boolean,
    subCols: any[],
    isExpanded: boolean,
    childPosition: number,
    prevHandlerState: IHandlerState;
}
export class DialogTableWrapper extends React.Component<IProps, IState> {
    public static isRunning: boolean = false;
    public selectTable: any = React.createRef();
    public myTableWrap: any = null;
    constructor(props: IProps) {
        super(props);
        this.state = {
            isEventAdded: false,
            shouldCheck: false,
            subCols: [],
            isExpanded: false,
            showDialog: false,
            timeout: false,
            errorMsg: '',
            childPosition: 99999,
            prevHandlerState: {
                prevIndex: 0,
                wasOpen: false
            }
        };
        this.handleMasterCheckSelection = this.handleMasterCheckSelection.bind(this);
        this.validateInput = this.validateInput.bind(this);
    }
    public componentDidMount() {
        this.myTableWrap = document.querySelector('.BookingDialogTable');
    }
    // This will launch only if propName value has chaged.
    public componentDidUpdate(props: any, state: any) {
        if (props.index !== this.props.index && this.props.data.length > 0) {
            if (this.props.data[this.props.index]) {
                this.setState({
                    subCols: this.props.data[this.props.index].children
                });
            }
            this.props.closeMethod();
            this.setSelected();
        }
        if (this.props.updateChildren !== props.updateChildren) {
            this.setState({
                subCols: this.props.data[this.props.index].children
            });
            this.setSelected();
        }
        if (this.props.data && this.props.data.length > 0 && this.props.data !== props.data) {
            this.setSelected();
            this.setState({ isEventAdded: false });
            // select children
            if (this.props.displayDistribution) {
                setTimeout(() => this.selectChildren(), 250);
            }
        }
    }
    public render() {
        const getCols = () => {
            switch (this.props.targetFunctionality) {
                case 5:
                    return CostColumnsData.getETSDialogSubCols();
                    break;
                case 4:
                    return CostColumnsData.getDialogFcrCostRevSubCols();
                    break;
                case 3:
                    return CostColumnsData.getDialogCblCostRevSubCols(this.props.isExtraDocumentFeatureEnabled);
                    break;
                case 2:
                    return CostColumnsData.getDialogEqCostRevSubCols(this.props.isExtraDocumentFeatureEnabled);
                    break;
                default:
                    return CostColumnsData.getDialogBookingCostRevSubCols(this.props.isExtraDocumentFeatureEnabled);
            }
        };
        if (this.props.data && this.props.columns && this.props.subColumns) {
            return (
                <div className={`table-group-relative ${this.props.isEditable ? currentPageMode.edit : ''}`}>
                    <InPageDialog
                        showDialog={this.state.showDialog}
                        type={'error'}
                        message={this.state.errorMsg}
                        closeMethod={() => this.setState({ showDialog: false, errorMsg: '' })} />
                    <div id="add-edit-dialog-table">
                        <DataTable
                            data={...this.props.data}
                        columns={...this.props.columns}
                        isEditable={false}
                        isSelectable={true}
                        selectedOption={'single'}
                        isSortable={true}
                        isExpandable={false}
                        isResizable={true}
                        hasFooter={true}
                        ref={this.selectTable}
                        showColumnOptions={false}
                        linkAction={this.onTargetClick}
                        actions={this.props.type === currentPageMode.add && this.props.data.length > 1 && {
                            secondaryActions: [],
                            parentContextualActions: []
                        }}
                        manualPagination={true}
                        fetchData={this.props.fetchData}
                        tableName={`BookingDialogTable`}
                        showPagination={this.props.data.length && this.props.data.length > 10 ? true : false}
                        />
                    </div>
                    <div className={`table-group-absolute ${this.props.classNameString && this.props.classNameString}`} id="distribution-data-table">
                        <p>Distribution Data:</p>
                        <DialogSubTableWrapper
                            data={this.props.data[this.props.index].children}
                            cols={getCols()}
                            onchange={(a: boolean, list: any[]) => {
                                if (list.length === 0) {
                                    this.handleMasterCheckSelection(a);
                                } else {
                                    this.props.onSelectCallBack(list);
                                }
                            }}
                            distributionType={this.props.distribution}
                            isSelectable={this.props.displayDistribution}
                            isEditable={this.props.distribution === 3}
                            subTableRef={this.props.subTableRef}
                            targetLevel={this.props.targetFunctionality}
                        /></div>
                </div>
            );
        } else {
            return <div />;
        }
    }
    public getInput = (indx: number, value: string = '0') => {
        const input = document.createElement('input');
        input.setAttribute('type', 'text');
        input.setAttribute('value', value);
        input.addEventListener('blur', (e: any) => this.validateInput(e, indx));
        return input;
    };
    public selectChildren = () => {
        const targ = this.props.data[this.props.index].children;
        const target: any = document.querySelector('.CostAndRevSubTable');
        let counter = 0;
        if (target) {
            for (let i = 0; i < targ.length; i++) {
                if (targ[i].Select) {
                    counter += 1;
                }
                // start from second element
                if (target.querySelectorAll('input[type=checkbox]')[i + 1]) {
                    target.querySelectorAll('input[type=checkbox]')[i + 1].checked = targ[i].Select;
                }
            }
            // check select all
            if (targ.length > 0 && counter === targ.length) {
                if (target.querySelectorAll('input[type=checkbox]')[0]) {
                    target.querySelectorAll('input[type=checkbox]')[0].checked = true;
                }
            }
        }
        if (this.props.data[this.props.index].distribution === 3 && target) {
            target.querySelectorAll('div[contenteditable]').forEach((el: any, index: number) => {
                if (el.parentElement.childElementCount === 1) {
                    el.parentElement.appendChild(this.getInput(index, el.textContent));
                }
            });
        }
    };
    public handleChildrenCheck = () => {
        const target: any = document.querySelector('.CostAndRevSubTable');
        let shouldSelect = true;
        this.props.data[this.props.index].children.map((el: any) => {
            if (!el.Select) {
                shouldSelect = false;
            }
        });
        if (shouldSelect && target) {
            target.querySelector('input[type=checkbox]').checked = shouldSelect;
        }
    };
    public validateInput = (ev: any, index: number) => {
        ev.preventDefault();
        if (this.props.data[this.props.index] && this.props.data[this.props.index].children[index]) {
            if (!isNaN(ev.currentTarget.value)) {
                this.props.onUpdateCallback(ev.currentTarget.value, index, true);
            } else {
                this.props.onUpdateCallback('0', index, true);
            }
        } else {
            ev.currentTarget.value = 0;
        }
    };
    public handleMasterCheckSelection = (value: boolean) => {
        // childIndex.stopPropagation();
        const targ = this.props.data[this.props.index].children;
        const arr: any[] = [];
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < targ.length; i++) {
            arr.push(value);
        }
        this.props.onSelectCallBack(arr);
    };
    public setSelected = () => {
        setTimeout(() => {
            const htmlEl = this.getTableRows();
            if (htmlEl) {
                const currentEl = htmlEl[this.props.index];
                if (currentEl && currentEl.parentElement) {
                    currentEl.classList.add('-selected');
                    if (currentEl.querySelector('input')) {
                        currentEl.querySelector('input').checked = true;
                    }
                }
            }
        }, 200);
    };
    public getTableRows = () => {
        if (!this.myTableWrap) {
            this.myTableWrap = document.querySelector('.BookingDialogTable');
        }
        if (this.myTableWrap) {
            const htmlEl = this.myTableWrap.querySelectorAll('.rt-tbody .rt-tr-group');
            if (htmlEl && htmlEl.length > 0) {
                // tslint:disable-next-line: prefer-for-of
                const lgt = htmlEl.length > this.props.data.length ? this.props.data.length : htmlEl.length;
                if (!this.state.isEventAdded) {
                    for (let i = 0; i < lgt; i++) {
                        if (htmlEl[i] && htmlEl[i].parentElement && i !== this.props.index) {
                            htmlEl[i].classList.remove('-selected');
                            if (htmlEl[i].querySelector('input')) {
                                htmlEl[i].querySelector('input').checked = false;
                                htmlEl[i].querySelector('input').addEventListener('click', (e: any) => {
                                    this.handleRadioSelection(e, i);
                                });
                            }
                        }
                    }
                    this.setState({ isEventAdded: true });
                }
            }
            return htmlEl;
        }
    };
    public handleRadioSelection = (ev: any, index: number) => {
        ev.preventDefault();
        ev.stopPropagation();
        this.props.setCurrentIndex(index);
    };
    public onTargetClick = (item: ICostBooking) => {
        if (this.props.deleteCharge) {
            this.props.deleteCharge(item, this.selectTable.current.getData());
        }
        this.getTableRows();
        const findById = findObjId(item.id, this.props.data, 'id');
        if (this.props.index !== findById && this.state.isExpanded) {
            this.setState({
                isExpanded: false,
                prevHandlerState: {
                    prevIndex: this.props.index,
                    wasOpen: false
                }
            });
        }
        this.setSelected();
    };
}